import axios from "axios";
import React, { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Badge from "../../components/badge/Badge";
import Footer from "../../components/footer/Footer";
import Navigation from "../../components/navigation/Navigation";
import { getJWT } from "../../helpers/Helper";
import "./serviceOrders.css";

const RenderLoading = () => (
  <div style={{ display: "flex", justifyContent: "center" }}>
    <Spinner animation="border" variant="darke" />
  </div>
);

function ServiceOrders() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState();

  useEffect(() => {
    setLoading(true);

    const jwt = getJWT();

    axios
      .get(`https://the-outlet-vendor-api.herokuapp.com/bookings/customer`, {
        headers: { Authorization: `Bearer ${jwt}` },
      })
      .then((res) => {
        setOrders(res && res.data);
        setLoading(false);
      })
      .catch((err) => {
        toast(`Oops! ${err.response.data.error}`, {
          type: "error",
          position: "top-right",
          autoClose: "1000",
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        setLoading(false);
        navigate("/error");
      });
  }, []);

  return (
    <div className="serviceOrders">
      <Navigation
        background="theme-color"
        logo="https://res.cloudinary.com/emacon-production/image/upload/v1654424700/the-outlet/2_cx772d.png"
      />

      <div className="section_1">
        {loading ? (
          RenderLoading()
        ) : (
          <div className="card_wrapper">
            <div className="border_wrapper">
              <h3>Service Bookings</h3>
            </div>

            {orders && orders.length ? (
              <React.Fragment>
                {orders.map((order) => (
                  <Row className="delivery" key={order.id}>
                    <Col
                      md={3}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <img
                        src={order.vendorService.imageUrl}
                        alt={order.vendorService.name}
                        className="product_img"
                      />
                    </Col>
                    <Col md={9}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <h4>{order.vendorService.name}</h4>
                        <Link
                          to={`/service-booking?service_id=${order.id}`}
                          className="see_details"
                        >
                          SEE DETAILS
                        </Link>
                      </div>
                      <p>{order.vendorService.service.name}</p>
                      <h6>{order.location}</h6>

                      <div style={{ display: "flex" }}>
                        <h6>{`Kshs ${order.totalAmount}`}</h6>
                        <h6 style={{ padding: "0rem 1rem" }}>{` (${
                          order.units
                        } ${order.unit}${order.units > 1 ? "s" : ""})`}</h6>
                      </div>

                      <Badge content={order.status} />

                      <div>
                        <Link
                          to={`/service-booking?service_id=${order.id}`}
                          className="mobilesee_details"
                        >
                          SEE DETAILS
                        </Link>
                      </div>
                    </Col>
                  </Row>
                ))}
              </React.Fragment>
            ) : (
              <div className="delivery">
                <h1>You don't have any Vendor Bookings</h1>
              </div>
            )}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}

export default ServiceOrders;
